module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg9-942b2eccf5f56a476ff5d14684269673.svg";